import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField
} from "@mui/material";
import api from "../api";

export default function ProductsList() {
  const [products, setProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", price: "", barcode: "" });

  const fetchProducts = async () => {
    const res = await api.get("/api.php?action=products_list");
    setProducts(res.data.data);
  };

  const handleSave = async () => {
    await api.post("/products", form);
    setOpen(false);
    fetchProducts();
  };

  const handleDelete = async (id) => {
    await api.delete(`/products/${id}`);
    fetchProducts();
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <div>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Add Product
      </Button>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Barcode</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map((p) => (
            <TableRow key={p.id}>
              <TableCell>{p.name}</TableCell>
              <TableCell>{p.price}</TableCell>
              <TableCell>{p.barcode}</TableCell>
              <TableCell>
                <Button onClick={() => handleDelete(p.id)}>Delete</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Add Product</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            fullWidth
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
          <TextField
            label="Price"
            type="number"
            fullWidth
            onChange={(e) => setForm({ ...form, price: e.target.value })}
          />
          <TextField
            label="Barcode"
            fullWidth
            onChange={(e) => setForm({ ...form, barcode: e.target.value })}
          />
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
